import { absolutePathWithArrayIndices } from "./absolutePath";

export interface AnalyticsApiParams {
  date_grouping: string;
  end_date: string;
  filters?: object;
  start_date: string;
}

export const analytics = {
  paywalls: {
    overview: {
      total_transactions: (params: AnalyticsApiParams) =>
        absolutePathWithArrayIndices(
          "analytics/paywalls/overview/total_transactions",
          params,
        ),
      total_revenue: (params: AnalyticsApiParams) =>
        absolutePathWithArrayIndices(
          "analytics/paywalls/overview/total_revenue",
          params,
        ),
      sales_breakdown: (params: AnalyticsApiParams) =>
        absolutePathWithArrayIndices(
          "analytics/paywalls/overview/sales_breakdown",
          params,
        ),
      revenue_breakdown: (params: AnalyticsApiParams) =>
        absolutePathWithArrayIndices(
          "analytics/paywalls/overview/revenue_breakdown",
          params,
        ),
      revenue_growth: (params: AnalyticsApiParams) =>
        absolutePathWithArrayIndices(
          "analytics/paywalls/overview/revenue_growth",
          params,
        ),
      highest_grossing_paywalls: (params: AnalyticsApiParams) =>
        absolutePathWithArrayIndices(
          "analytics/paywalls/overview/highest_grossing_paywalls",
          params,
        ),
    },
    one_time: {
      total_transactions: (params: AnalyticsApiParams) =>
        absolutePathWithArrayIndices(
          "analytics/paywalls/one_time/total_transactions",
          params,
        ),
      total_revenue: (params: AnalyticsApiParams) =>
        absolutePathWithArrayIndices(
          "analytics/paywalls/one_time/total_revenue",
          params,
        ),
      revenue_growth: (params: AnalyticsApiParams) =>
        absolutePathWithArrayIndices(
          "analytics/paywalls/one_time/revenue_growth",
          params,
        ),
      average_order_value: (params: AnalyticsApiParams) =>
        absolutePathWithArrayIndices(
          "analytics/paywalls/one_time/average_order_value",
          params,
        ),
      repurchases: (params: AnalyticsApiParams) =>
        absolutePathWithArrayIndices(
          "analytics/paywalls/one_time/repurchases",
          params,
        ),
    },
    installments: {
      installment_revenue: (params: AnalyticsApiParams) =>
        absolutePathWithArrayIndices(
          "analytics/paywalls/installments/installment_revenue",
          params,
        ),
      active_installments: (params: AnalyticsApiParams) =>
        absolutePathWithArrayIndices(
          "analytics/paywalls/installments/active_installments",
          params,
        ),
      installments_revenue_growth: (params: AnalyticsApiParams) =>
        absolutePathWithArrayIndices(
          "analytics/paywalls/installments/installments_revenue_growth",
          params,
        ),
    },
  },
};
